
import { ImportDataClient } from '@/services/Services';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';
import ImportErrorsModal from '../modals/importErrorsModal.vue';

@Options({
    components: {},
})
export default class MyImports extends Vue {

    importList: OM.MyImportsVM[] = [];
    pollInterval: any = null;

    created() {
        this.init();
    }

    unmounted() {
        this.clearPoll();
    }

    init() {
        ImportDataClient.getMyImports()
        .then(x => {
            this.importList = x;
            this.schedulePoll();
        });
    }

    schedulePoll() {
        this.clearPoll();
        const hasActive = this.importList.some(x => x.status === 'Pending' || x.status === 'Processing');
        if (hasActive) {
            this.pollInterval = setInterval(() => {
                ImportDataClient.getMyImports(false)
                .then(x => {
                    this.importList = x;
                    const stillActive = x.some(r => r.status === 'Pending' || r.status === 'Processing');
                    if (!stillActive) {
                        this.clearPoll();
                    }
                });
            }, 5000);
        }
    }

    clearPoll() {
        if (this.pollInterval !== null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    }

    calcStatusLabel(status: string): string {
        if (status === 'Processing') return 'Processing';
        if (status === 'Done') return 'Completed';
        if (status === 'Failed') return 'Error';
        if (status === 'Pending') return 'Queued';
        return '';
    }

    showErrors(item: OM.MyImportsVM) {
        this.$opModal.show(ImportErrorsModal, { importId: item.identifier });
    }

}
